module.exports = __webpack_public_path__ + "img/changeProfile-1.2a0f617.png";